export function isErrorResponse(response) {
  return response && response.status === 422;
}

export function extractErrorsFromResponse(response) {
  return response.data.errors;
}
